import classNames from "classnames/bind";
import Info from "common/blocks/Info";
import RichText from "common/blocks/RichText";
import useFinanceDataContext from "features/vehicleDetails/providers/financeData/useFinanceDataContext";
import { PartExchange } from "services/motorpoint/partExchange";
import { VehicleService } from "services/vehicle/vehicle";

import FinanceCalculator, { FinanceCalculatorProps } from "../FinanceCalculator";
import StoreLocation, { StoreLocationProps } from "../StoreLocation";
import styles from "./FinanceRow.module.scss";

const cx = classNames.bind(styles);

export type FinanceRowProps = {
    partExchange?: PartExchange;
    components: {
        financeCalculator: FinanceCalculatorProps;
        storeLocation: StoreLocationProps;
    };
    isComingSoon?: boolean;
    externalIds: VehicleService.ExternalId[];
};

export const FinanceRow = ({
    partExchange,
    components,
    isComingSoon,
    externalIds,
}: FinanceRowProps) => {
    const { isHpShowing } = useFinanceDataContext();
    return (
        <div className={cx("financeRow")}>
            <div className={cx("col", "colFirst", { "financeRow-isComingSoon": isComingSoon })}>
                <FinanceCalculator
                    {...components.financeCalculator}
                    partExchange={partExchange}
                    externalIds={externalIds}
                />
            </div>
            {!isComingSoon && (
                <div className={cx("col", "colMiddle")}>
                    <StoreLocation {...components.storeLocation} />
                </div>
            )}
            <div className={cx("col", "colLast")}>
                {!isHpShowing && !!components.financeCalculator.settings.legalText?.html && (
                    <Info>
                        <RichText {...components.financeCalculator.settings.legalText} />
                    </Info>
                )}
                {isHpShowing && !!components.financeCalculator.settings.legalTextHp?.html && (
                    <Info>
                        <RichText {...components.financeCalculator.settings.legalTextHp} />
                    </Info>
                )}
            </div>
        </div>
    );
};
